import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { ComponentsComponent } from './components/components.component';
import { ProfileComponent } from './examples/profile/profile.component';
import { SignupComponent } from './examples/signup/signup.component';
import { LandingComponent } from './examples/landing/landing.component';
import { NucleoiconsComponent } from './components/nucleoicons/nucleoicons.component';
import { MedecinComponent } from './page/medecin/medecin.component';
import { InfrastructureComponent } from './page/infrastructure/infrastructure.component';
import { QuestonaireComponent } from './page/questonaire/questonaire.component';
//import { VoireQuestionComponent} from './page/questonaire/voire-question/voire-question.component';
import { MesHistoriqueComponent } from './page/mes-historique/mes-historique.component';
import { ConsulatationMedicaleComponent } from './page/consulatation-medicale/consulatation-medicale.component';
import { EvaluationEnligneComponent } from './page/evaluation-enligne/evaluation-enligne.component';
import { RemboursementComponent } from './page/remboursement/remboursement.component';
import { AnalyseComponent } from './page/analyse/analyse.component';
import { IecComponent } from './page/information/iec/iec.component';

import { ArticleComponent } from './page/information/article/article.component';
import { Article2Component } from './page/information/article2/article2.component';



import { ContactComponent } from './page/information/contact/contact.component';
import { TextComponent } from './page/information/text/text.component';
import { MedecinTszComponent } from './page/medecin-tsz/medecin-tsz.component';
import { MedecinAnsComponent } from './page/medecin-ans/medecin-ans.component';
import { InfoAnalyseComponent } from './page/info-analyse/info-analyse.component';
import { AffichageConsultationComponent } from './page/consulatation-medicale/affichage-consultation/affichage-consultation.component';
import { ProcedureConsultationComponent } from './page/consulatation-medicale/procedure-consultation/procedure-consultation.component';
import { StatistiqueConsultationComponent } from './page/consulatation-medicale/statistique-consultation/statistique-consultation.component';
import { InfoRembourseComponent } from './page/remboursement/info-rembourse/info-rembourse.component';
import { ProcedureRembourseComponent } from './page/remboursement/procedure-rembourse/procedure-rembourse.component';
import { StatistiqueRembourseComponent } from './page/remboursement/statistique-rembourse/statistique-rembourse.component';
import { DetailIecComponent } from './page/information/detail-iec/detail-iec.component';
import { CalendrierMedecinComponent } from './page/consulatation-medicale/calendrier-medecin/calendrier-medecin.component';
import { RapportActiviteComponent } from './page/rapport-activite/rapport-activite.component';


import { RappertActiviterRembComponent } from './page/rapport-activite/rappert-activiter-remb/rappert-activiter-remb.component';
import { RappertActiviterMedComponent } from './page/rapport-activite/rappert-activiter-med/rappert-activiter-med.component';
import { RappertActiviterAutComponent } from './page/rapport-activite/rappert-activiter-aut/rappert-activiter-aut.component';
 
import { RapportActiviterRembourseComponent } from './page/rapport-activite/rapport-activiter-rembourse/rapport-activiter-rembourse.component';
import { RapportActiviterMedecinComponent } from './page/rapport-activite/rapport-activiter-medecin/rapport-activiter-medecin.component';
import { RapportActiviterAutreComponent } from './page/rapport-activite/rapport-activiter-autre/rapport-activiter-autre.component';




import { NosInfrastructureComponent } from './page/nos-infrastructure/nos-infrastructure.component';
import { SatistiqueConsultationAgentComponent } from './page/consulatation-medicale/satistique-consultation-agent/satistique-consultation-agent.component';
import { SatistiqueConsultationMedComponent } from './page/consulatation-medicale/satistique-consultation-med/satistique-consultation-med.component';
import { StatistiqueRembourseAgentComponent } from './page/remboursement/statistique-rembourse-agent/statistique-rembourse-agent.component';
import { StatistiqueRembourseTraiteComponent } from './page/remboursement/statistique-rembourse-traite/statistique-rembourse-traite.component';
import { StatistiqueGlobalComponent } from './page/statistique-global/statistique-global.component';
import { StatistiqueGlobalRemboursementComponent } from './page/statistique-global/statistique-global-remboursement/statistique-global-remboursement.component';
import { StatistiqueGlobalConsultationComponent } from './page/statistique-global/statistique-global-consultation/statistique-global-consultation.component';
import { StatistiqueGlobalReposMedicaleComponent } from './page/statistique-global/statistique-global-repos-medicale/statistique-global-repos-medicale.component';
import { StatistiqueGlobalAgentEtFamilleComponent } from './page/statistique-global/statistique-global-agent-et-famille/statistique-global-agent-et-famille.component';
import { BibliothequeVirtuelleComponent } from './page/bibliotheque-virtuelle/bibliotheque-virtuelle.component';
import { StatistiqueReposAgentComponent } from './page/consulatation-medicale/statistique-repos-agent/statistique-repos-agent.component';
import { GestionMedicamentComponent } from './page/gestion-medicament/gestion-medicament.component';
import { MedicamentConsommerParAgentComponent } from './page/gestion-medicament/medicament-consommer-par-agent/medicament-consommer-par-agent.component';
import { GestionMedicamentPharmacieComponent } from './page/gestion-medicament/gestion-medicament-pharmacie/gestion-medicament-pharmacie.component';


import { GestionMedicamentEntrepotComponent } from './page/gestion-medicament/gestion-medicament-entrepot/gestion-medicament-entrepot.component';
import { MedicamentLivrerComponent } from './page/gestion-medicament/medicament-livrer/medicament-livrer.component';
import { ViewMedicamentLivrerComponent } from './page/gestion-medicament/medicament-livrer/view-medicament-livrer/view-medicament-livrer.component';
import { MedParPharmacieComponent } from './page/gestion-medicament/gestion-medicament-pharmacie/med-par-pharmacie/med-par-pharmacie.component';
import { VoireQuestionComponent } from './page/questonaire/voire-question/voire-question.component';
import { IndexComponent } from './examples/index/index.component';
import { AuthGard } from './services/auth-gard.service';
import { DetailEnvironementComponent } from './page/bibliotheque-virtuelle/detail-environement/detail-environement.component';
import { DetailTextComponent } from './page/information/detail-text/detail-text.component';
import { ListeQuestionAgentComponent } from './page/questonaire/liste-question-agent/liste-question-agent.component';
import { IecEpidemieComponent } from './page/information/iec-epidemie/iec-epidemie.component';
import { MedecinCmsComponent } from './examples/index/medecin-cms/medecin-cms.component';
import { LutteContreEpidemieComponent } from './page/infrastructure/lutte-contre-epidemie/lutte-contre-epidemie.component';
import { BcComponent } from './page/consulatation-medicale/bc/bc.component';
import { ValiditationBcComponent } from './page/consulatation-medicale/validitation-bc/validitation-bc.component';
import { DetailBcComponent } from './page/consulatation-medicale/detail-bc/detail-bc.component';
import { FormValidBcComponent } from './page/consulatation-medicale/form-valid-bc/form-valid-bc.component';
import { AdminComponent } from './examples/admin/admin.component';
import { ImagevideocovidComponent } from './page/information/iec-epidemie/imagevideocovid/imagevideocovid.component';
import { DetailEpidemieComponent } from './page/information/iec-epidemie/detail-epidemie/detail-epidemie.component';
import { Article3Component } from './page/information/article3/article3.component';



//import { WSAEFAULT } from 'constants';

const routes: Routes = [
  { path: '', redirectTo: 'index', pathMatch: 'full' },  
  
  { path: 'index', component: IndexComponent },
  { path: 'medecins', component: MedecinCmsComponent },

  { path: 'home', component: ComponentsComponent ,canActivate: [AuthGard]  },
  { path: 'user-profile', component: ProfileComponent  ,canActivate: [AuthGard]  },
  { path: 'login', component: SignupComponent },
  { path: 'landing', component: LandingComponent  ,canActivate: [AuthGard]},
  { path: 'nucleoicons', component: NucleoiconsComponent  ,canActivate: [AuthGard]},
  //li ,

  { path: 'admin-', component: AdminComponent  },  

  { path: 'infra', component: NosInfrastructureComponent  ,canActivate: [AuthGard]},   
  { path: 'geste-barr', component: LutteContreEpidemieComponent  ,canActivate: [AuthGard]},
  

  { path: 'medecin', component: MedecinComponent  ,canActivate: [AuthGard]},
  { path: 'medecin-tsz', component: MedecinTszComponent  ,canActivate: [AuthGard] },
  { path: 'medecin-ans', component: MedecinAnsComponent  ,canActivate: [AuthGard] },


  { path: 'consultation', component: InfrastructureComponent  ,canActivate: [AuthGard] },
  { path: 'cons-affiche', component: AffichageConsultationComponent  ,canActivate: [AuthGard] },
  { path: 'cons-procedure/:id', component: ProcedureConsultationComponent  ,canActivate: [AuthGard] },
  { path: 'agenda/:id', component: CalendrierMedecinComponent  ,canActivate: [AuthGard] },
   { path: 'agenda', component: CalendrierMedecinComponent   ,canActivate: [AuthGard]},
  { path: 'agenda/:id/:id2', component: CalendrierMedecinComponent  ,canActivate: [AuthGard] },
  { path: 'cons-statistique', component: StatistiqueConsultationComponent  ,canActivate: [AuthGard] },
  { path: 'statistic-cons-agent/:id', component: SatistiqueConsultationAgentComponent  ,canActivate: [AuthGard] },
  { path: 'statistic-cons-medicin/:id', component: SatistiqueConsultationMedComponent  ,canActivate: [AuthGard] },
  { path: 'statistic-repos-agent/:id', component: StatistiqueReposAgentComponent ,canActivate: [AuthGard] },
  { path: 'bc', component: BcComponent  ,canActivate: [AuthGard] },
  { path: 'list-bc', component: ValiditationBcComponent  ,canActivate: [AuthGard] },
  { path: 'detail-bc/:id', component: DetailBcComponent  ,canActivate: [AuthGard] },
  { path: 'valid-bc/:id', component: FormValidBcComponent  ,canActivate: [AuthGard] },
   
  

  { path: 'question', component: QuestonaireComponent ,canActivate: [AuthGard] },
  { path: 'detail-question/:id', component: VoireQuestionComponent ,canActivate: [AuthGard] },
  { path: 'detail-question/:id/:id2', component: VoireQuestionComponent  ,canActivate: [AuthGard]},
  { path: 'questions', component: ListeQuestionAgentComponent, canActivate: [AuthGard]  },
  
  
  { path: 'mes-histoirque', component: MesHistoriqueComponent  ,canActivate: [AuthGard] },
  { path: 'cons-medical', component: ConsulatationMedicaleComponent  ,canActivate: [AuthGard] },
  { path: 'evaluation/:id', component: EvaluationEnligneComponent  ,canActivate: [AuthGard] },
  { path: 'rapport', component: RapportActiviteComponent  ,canActivate: [AuthGard] },

  { path: 'rapport-med', component: RappertActiviterMedComponent  ,canActivate: [AuthGard] },
  { path: 'rapport-remb', component: RappertActiviterRembComponent  ,canActivate: [AuthGard] },
  { path: 'rapport-autre', component: RappertActiviterAutComponent  ,canActivate: [AuthGard] },

  { path: 'rapport-med-det/:id', component: RapportActiviterMedecinComponent  ,canActivate: [AuthGard] },
  { path: 'rapport-remb-det/:id', component: RapportActiviterRembourseComponent  ,canActivate: [AuthGard] },
  { path: 'rapport-autre-det/:id', component: RapportActiviterAutreComponent  ,canActivate: [AuthGard] }, 




  { path: 'info-remborse', component: InfoRembourseComponent  ,canActivate: [AuthGard] },
  { path: 'procedure-remborse', component: ProcedureRembourseComponent  ,canActivate: [AuthGard] },
  { path: 'mes-remboursement', component: RemboursementComponent  ,canActivate: [AuthGard] },
  { path: 'statistique-remborse', component: StatistiqueRembourseComponent  ,canActivate: [AuthGard] },
  { path: 'statistic-rembours-agent', component: StatistiqueRembourseAgentComponent  ,canActivate: [AuthGard] },
  { path: 'statistic-rembours-traite/:id', component: StatistiqueRembourseTraiteComponent  ,canActivate: [AuthGard] },



  { path: 'info-analyse', component: InfoAnalyseComponent  ,canActivate: [AuthGard] },
  { path: 'mes-analyse', component: AnalyseComponent  ,canActivate: [AuthGard] },


  { path: 'iec', component: IecComponent  ,canActivate: [AuthGard]},
  { path: 'iec-epidemie', component: IecEpidemieComponent ,canActivate: [AuthGard]},
   { path: 'iec-epidemie-info', component: DetailEpidemieComponent ,canActivate: [AuthGard] },
  { path: 'iec-epidemie-info/:id', component: DetailEpidemieComponent ,canActivate: [AuthGard] },

   { path: 'article', component: ArticleComponent ,canActivate: [AuthGard] },
    { path: 'article2', component: Article2Component ,canActivate: [AuthGard] },
    { path: 'article3', component: Article3Component ,canActivate: [AuthGard] },
   

  
  
  { path: 'iec-media/:id', component: ImagevideocovidComponent  ,canActivate: [AuthGard]},
  { path: 'detail-iec/:id/:id2', component: DetailIecComponent  ,canActivate: [AuthGard] },

  { path: 'text', component: TextComponent ,canActivate: [AuthGard] },
  { path: 'detail_text/:id', component: DetailTextComponent  ,canActivate: [AuthGard] },
  { path: 'contact', component: ContactComponent  ,canActivate: [AuthGard] },


  
  { path: 'biblioteque', component: BibliothequeVirtuelleComponent  ,canActivate: [AuthGard] },
   
  { path: 'detail_biblio/:id', component: DetailEnvironementComponent  ,canActivate: [AuthGard] },
  
  { path: 'gestion-med', component: GestionMedicamentComponent  ,canActivate: [AuthGard] },
  { path: 'gestion-med-pharmacie', component: GestionMedicamentPharmacieComponent  ,canActivate: [AuthGard] },
  { path: 'gestion-med-par-pharmacie/:id', component: MedParPharmacieComponent  ,canActivate: [AuthGard] },


  { path: 'gestion-med-entrepot', component: GestionMedicamentEntrepotComponent  ,canActivate: [AuthGard] },
  { path: 'med-consomme', component: MedicamentConsommerParAgentComponent  ,canActivate: [AuthGard] },
  { path: 'med-livre', component: MedicamentLivrerComponent  ,canActivate: [AuthGard] },
  { path: 'view-med-livre/:id', component: ViewMedicamentLivrerComponent  ,canActivate: [AuthGard] }, 

 
  { path: 'statistic-global', component: StatistiqueGlobalComponent  ,canActivate: [AuthGard] },  
  { path: 'statistic-global-agent', component: StatistiqueGlobalAgentEtFamilleComponent  ,canActivate: [AuthGard] },
  { path: 'statistic-global-cons', component: StatistiqueGlobalConsultationComponent  ,canActivate: [AuthGard] },
  { path: 'statistic-global-repos', component: StatistiqueGlobalReposMedicaleComponent  ,canActivate: [AuthGard] },
  { path: 'statistic-global-rembours', component: StatistiqueGlobalRemboursementComponent ,canActivate: [AuthGard] }
  





        

  





];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, {
      useHash: true
    })
  ],
  exports: [
  ],
})
export class AppRoutingModule { }



